<header id="page-topbar" data-scroll-header (window:scroll)="windowScroll()">
    <div class="layout-width">
        <div class="navbar-header d-flex">
            <div class="flex-shrink-0 d-flex">
                <!-- LOGO -->
                <div class="navbar-brand-box horizontal-logo">
                    <a routerLink="/" class="logo logo-dark">
                        <span class="logo-sm ms-n3">
                            <img src="assets/brandimages/{{vendoruniquekey}}/logo-sm.png" alt="" height="26">
                        </span>
                        <span class="logo-lg ms-n1">
                            <img src="assets/brandimages/{{vendoruniquekey}}/logo-light.png" alt="" width="120">
                        </span>
                    </a>

                    <a routerLink="/" class="logo logo-light">
                        <span class="logo-sm ms-n3">
                            <img src="assets/brandimages/{{vendoruniquekey}}/logo-sm.png" alt="" height="26">
                        </span>
                        <span class="logo-lg ms-n1">
                            <img src="assets/brandimages/{{vendoruniquekey}}/logo-light.png" alt="" width="120">
                        </span>
                    </a>
                </div>

                <button type="button" class="btn btn-sm px-3 fs-16 header-item vertical-menu-btn topnav-hamburger"
                    id="topnav-hamburger-icon" (click)="toggleMobileMenu($event)">
                    <span class="hamburger-icon">
                        <span></span>
                        <span></span>
                        <span></span>
                    </span>
                </button>

                <!-- App Search-->
                <form class="app-search d-none d-md-block">
                    <div class="position-relative">
                        <button type="button" class="search-button btn border btn-label waves-effect waves-light"
                            (click)="openglobalsearch()">
                            <i class="mdi mdi-magnify label-icon align-middle fs-16 me-2"></i> Search...
                            <span class="fs-14 align-middle"><i
                                    class="mdi mdi-apple-keyboard-command fs-13"></i>K</span>
                        </button>
                    </div>
                </form>
              
            </div>

            <div class="flex-shrink-1" style="overflow: hidden;  white-space: nowrap; min-width: 0;">
                <app-message-ticker></app-message-ticker>
             </div>

            <div class="d-flex flex-shrink-0 align-items-center">
           
                @if(isuservendor && (userData.role?.id == roles.Superadmin || userData.role?.id == roles.Admin)){
                <div class="header-item d-none d-sm-flex">
                    <a target="_blank" (click)="openHubPortal()" class="btn shadow-lg text-white rounded-pill me-2"
                        style="background: linear-gradient(to right, #fe8c00, #f83600); border: transparent;">
                        <img src="assets/images/database.png" alt="Logo"
                            height="14">
                        Hub
                    </a>
                </div>
                }
                
                <!-- @if(isuservendor && userData.role?.id == roles.Superadmin && !userData.subscriptionactivated){
                    <div class="header-item d-none d-sm-flex">
                        <button type="button" class="btn shadow-lg text-body rounded-pill me-2 p-0 border border-2"
                            style="padding: 6px 12px !important;"
                            (click)="openmeetzaipopup()">
                            <img src="assets/images/zai/zaifacesmall.png" class="zai-topbar-btn">
                            Ask ZAI
                        </button>
                    </div>
                }
                    <div class="header-item d-none d-sm-flex">
                        <button type="button" class="btn shadow-lg text-white rounded-pill me-2"
                            style="background: linear-gradient(to right, #fe8c00, #f83600); border: transparent;"
                            (click)="activate()">Activate</button>
                    </div>
                <div class="header-item d-none d-sm-flex">
                    <button type="button" class="btn shadow-lg text-white rounded-pill me-2"
                        style="background: linear-gradient(to right, #fe8c00, #f83600); border: transparent;"
                        (click)="upgrade()">Upgrade</button>
                </div>
                } -->

                @if(userData.role?.id !== roles.Member){
                <div class="header-item d-none d-sm-flex">
                    <button type="button" class="btn shadow-lg text-white rounded-pill "
                        style="background: linear-gradient(to bottom right, #333333, #3a3a3a); border: transparent;"
                        (click)="scheduledemo()">Schedule
                        Demo</button>
                </div>
                }

                <div class="header-item d-none d-sm-flex">
                    <button type="button" class="btn btn-icon btn-topbar btn-ghost-primary rounded-circle"
                        data-toggle="fullscreen" (click)="fullscreen()">
                        <i class='bx bx-fullscreen fs-16'></i>
                    </button>
                </div>

                <div class="header-item d-none d-sm-flex">
                    <button type="button"
                        class="btn btn-icon btn-topbar btn-ghost-primary rounded-circle light-dark-mode">
                        <i class='bx bx-moon fs-16' (click)="changeMode('dark')"></i>
                        <i class='bx bx-sun fs-16' (click)="changeMode('light')"></i>
                    </button>
                </div>

                <div class="dropdown header-item d-none d-sm-flex">
                    <a class="btn btn-icon btn-topbar btn-ghost-primary rounded-circle" routerLink="/tickets/list" href="#"><i class='mdi mdi-progress-question fs-18'></i></a>
                </div>

                <div ngbDropdown [autoClose]="false" class="dropdown topbar-head-dropdown ms-1 header-item">
                    <button type="button" ngbDropdownToggle
                        class="btn btn-icon btn-topbar btn-ghost-primary rounded-circle"
                        id="page-header-notifications-dropdown" data-bs-toggle="dropdown" aria-haspopup="true"
                        aria-expanded="false">
                        <i class='bx bx-bell fs-20'></i>
                        @if(totalunreads > 0){
                        <span
                            class="position-absolute topbar-badge fs-10 translate-middle badge rounded-pill bg-danger">{{totalunreads}}<span
                                class="visually-hidden">unread messages</span></span>
                        }
                    </button>
                    <div ngbDropdownMenu class="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
                        aria-labelledby="page-header-notifications-dropdown">

                        <div class="dropdown-head bg-primary  bg-pattern rounded-top">
                            <div class="p-3">
                                <div class="row align-items-center">
                                    <div class="col">
                                        <h6 class="m-0 fs-16 fw-semibold text-white"> Unread </h6>
                                    </div>
                                    <div class="col-auto dropdown-tabs">
                                        <span class="badge bg-body-subtle text-body fs-13"> {{totalunreads}} New</span>
                                    </div>
                                </div>
                            </div>

                            <div class="px-2 pt-2">
                                <ul ngbNav #nav="ngbNav" [activeId]="1"
                                    class="nav nav-tabs dropdown-tabs nav-tabs-custom" id="notificationItemsTab">
                                    <li [ngbNavItem]="1">
                                        <a ngbNavLink (click)="onNavLinkClick($event)">
                                            Notifications ({{unreadnotificationscount}})
                                        </a>
                                        <ng-template ngbNavContent>
                                            <div class="tab-pane fade show active py-2 ps-2" id="all-noti-tab"
                                                role="tabpanel">
                                                <ngx-simplebar style="max-height: 300px;">
                                                    <div class="pe-2">
                                                        @for(item of allnotifications; track $index){
                                                            <div class="text-reset notification-item d-block dropdown-item"
                                                            (click)="openRecordDetailsPage(item)">
                                                            <div class="d-flex">
                                                                <div class="flex-shrink-0 avatar-xs">
                                                                    <span><i class="fs-18 mdi mdi-bell-circle-outline"></i></span>
                                                                </div>
                                                                <div class="flex-grow-1">
                                                                    <a href="javascript:void(0);"
                                                                        class="stretched-link">
                                                                        <h6 class="mt-0 mb-1 text-capitalize">
                                                                            {{item.attributes?.title}}
                                                                        </h6>
                                                                    </a>
                                                                    <div class="fs-11 text-muted">
                                                                        <p class="mb-1">{{item.attributes?.description}}</p>
                                                                    </div>
                                                                    <p
                                                                        class="mb-0 fs-11 fw-medium text-uppercase text-muted">
                                                                        <span><i class="mdi mdi-clock-outline"></i>
                                                                            {{item.attributes?.createdAt | date :'medium'}}</span>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        } @empty{
                                                            <div [ngClass]="allnotifications.length != 0 ?'d-none':''"
                                                            class="tab-pane p-4" id="alerts-tab" role="tabpanel"
                                                            aria-labelledby="alerts-tab">
                                                            <div class="text-center pb-5 mt-2">
                                                                <h6 class="fs-18 fw-semibold lh-base">Hey! You have no
                                                                    notifications</h6>
                                                            </div>
                                                        </div>
                                                        }
                                                        <div class="my-3 text-center">
                                                            <button type="button" (click)="opennotificationscanvas()" class="btn btn-soft-success waves-effect waves-light">View
                                                                all notifications <i class="mdi mdi-arrow-right-bold align-middle"></i></button>
                                                        </div>
                                                    </div>


                                                </ngx-simplebar>
                                            </div>
                                        </ng-template>
                                    </li>
                                </ul>
                            </div>

                        </div>

                        <div class="tab-content" id="notificationItemsTabContent">
                            <div class="tab-content text-muted">
                                <div [ngbNavOutlet]="nav"></div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="dropdown ms-sm-1 header-item topbar-user" ngbDropdown>
                    <button type="button" class="btn" id="page-header-user-dropdown" data-bs-toggle="dropdown"
                        aria-haspopup="true" aria-expanded="false" ngbDropdownToggle>
                        <span class="d-flex align-items-center">
                            @if(userData.userprofile!.profilepic){
                            <div class="avatar-xs img-thumbnail rounded-circle flex-shrink-0"
                                [ngStyle]="{'background-color': (isuservendor) ? '#495057' : '#F48F1D'}">
                                <img src="{{userData.userprofile!.profilepic.url}}"
                                    class="rounded-circle header-profile-user" alt="">
                            </div>
                            }@else{
                            <div class="avatar-xs img-thumbnail rounded-circle flex-shrink-0"
                                [ngStyle]="{'background-color': (isuservendor) ? '#495057' : '#F48F1D'}">
                                <div class="avatar-title border bg-body text-body rounded-circle text-uppercase">
                                    {{ userData.name?.charAt(0) }}</div>
                            </div>
                            }
                        </span>
                    </button>
                    <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
                        <div class="text-center">
                            <h5 class="dropdown-header text-capitalize pb-0">Welcome {{userData.name == "" ? "User" :
                                userData.name}}!
                            </h5>
                            <span class="text-muted fs-10 text-center">{{userData.role ? userData.role.name : 'User Role'}}</span>
                            @if(userData.role!.id != this.roles.Member){
                            @if(isuservendor){
                                @if(areearningsvisible){
                                    <h6 class="fw-normal"><i class="mdi mdi-wallet text-muted fs-16 align-middle me-1"></i>
                                        <span class="align-middle text-muted">Earnings :
                                            <b>${{userearnings}}</b></span>
                                    </h6>
                                }
                            }@else {
                            <h6 class="fw-normal"><i class="mdi mdi-wallet text-muted fs-16 align-middle me-1"></i>
                                <span class="align-middle text-muted">Balance :
                                    <b>${{userwalletbalance}}</b></span>
                            </h6>
                            }
                            }
                        </div>
                        <div class="dropdown-divider"></div>
                        <a class="dropdown-item btn" (click)="openViewDetailsCanvas()"><i
                                class="mdi mdi-account-circle text-muted fs-16 align-middle me-1"></i> <span
                                class="align-middle">View Profile</span></a>
                        <a class="dropdown-item btn" (click)="openChangepasswordDialog(changepasswordmodel)"><i
                                class="mdi mdi-account-key text-muted fs-16 align-middle me-1"></i> <span
                                class="align-middle">Change Password</span></a>
                        @if(!isuservendor){
                        <a class="dropdown-item btn" (click)="openrechargewalletmodal()"><i
                                class="mdi mdi-wallet-plus text-muted fs-16 align-middle me-1"></i> <span
                                class="align-middle">Recharge Wallet</span></a>
                        }
                        <div class="dropdown-divider"></div>
                        <!-- <a class="dropdown-item" routerLink="/pages/settings"><span
                                class="badge bg-success-subtle text-success mt-1 float-end">New</span><i
                                class="mdi mdi-cog-outline text-muted fs-16 align-middle me-1"></i> <span
                                class="align-middle">Settings</span></a> -->
                        <a class="dropdown-item btn" (click)="logout()"><i
                                class="mdi mdi-logout text-muted fs-16 align-middle me-1"></i> <span
                                class="align-middle" data-key="t-logout">Logout</span></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</header>

<app-rechargewallet #rechargeWalletModal></app-rechargewallet>
<app-viewmemberdetails #viewProfileContent></app-viewmemberdetails>
<app-globalsearch #globalsearchContent></app-globalsearch>
<app-notificationsidewindow #notificationswindow></app-notificationsidewindow>
<app-meetzaipopup #meetzaiModal></app-meetzaipopup>


<ng-template #changepasswordmodel role="document" let-modal>
    <div class="modal-header">
        <h5 class="modal-title" id="changepwdLabel">Change Password</h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="dismisschangepasswordmodal()"> </button>
    </div>
    <div class="modal-body">
        <app-changepassworddialog></app-changepassworddialog>
    </div>
</ng-template>